<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaServiciu')}}</h4>
        </div>
        <form class="add-user-form" id='edit-service' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_1" :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               @input="calculateFinalPrice"
                               @change="calculateFinalPrice">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               v-model="input_field.inputValue">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12 col-xs-12 col-lg-12">
                    <button type="button" @click='updateService()'>
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ServicesService from '../../api-services/services.service.js'
export default {
  name: 'editsubtype',
  data () {
    return {
      service: []
    }
  },
  methods: {
    calculateFinalPrice ({ target }) {
      if (target.name === 'standard_price' || target.name === 'discount') {
        let standardPrice = parseInt(document.getElementsByName('standard_price')[0].value, 10)
        standardPrice = standardPrice > 0 ? standardPrice : 0
        this.service.standard_price = standardPrice
        let discount = parseInt(document.getElementsByName('discount')[0].value, 10)
        discount = discount > 0 ? discount : 0
        this.service.discount = discount
        this.service.final_price = parseInt(standardPrice * (100 - discount) / 100, 10)
        this.service.final_price = this.service.final_price > 0 ? this.service.final_price : 0
      }
    },
    getService () {
      ServicesService.get(this.$route.params.id)
        .then((response) => {
          this.service = response.data.data
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    updateService () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-service'))

      ServicesService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.service = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.serviciuModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.service) ? this.service.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'standard_price',
            labelName: this.$t('placeholder.pretStandard'),
            inputValue: (this.service) ? this.service.standard_price : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.service) ? this.service.discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          },
          {
            inputName: 'final_price',
            labelName: this.$t('placeholder.pretFinal'),
            inputValue: (this.service) ? this.service.final_price : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'cost_acquisition',
            labelName: this.$t('placeholder.costAchizitie'),
            inputValue: (this.service) ? this.service.cost_acquisition : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'addition',
            labelName: this.$t('placeholder.adaosComercial'),
            inputValue: (this.service) ? this.service.addition : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'max_discount',
            labelName: this.$t('placeholder.discountMaxim'),
            inputValue: (this.service) ? this.service.max_discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          }
        ]
      }
    }
  },
  created () {
    this.getService()
  }
}
</script>
